export function getFilenameFromContentDisposition(
  contentDisposition: string | null,
  fallbackFilename = "download.pgn",
): string {
  if (!contentDisposition) {
    return fallbackFilename;
  }

  const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1]);
    } catch {
      return utf8Match[1];
    }
  }

  const quotedMatch = /filename="([^"]+)"/i.exec(contentDisposition);
  if (quotedMatch?.[1]) {
    return quotedMatch[1];
  }

  const unquotedMatch = /filename=([^;]+)/i.exec(contentDisposition);
  if (unquotedMatch?.[1]) {
    return unquotedMatch[1].trim();
  }

  return fallbackFilename;
}

export function triggerBrowserDownload(blob: Blob, filename: string): void {
  const objectUrl = URL.createObjectURL(blob);

  try {
    const anchor = document.createElement("a");
    anchor.href = objectUrl;
    anchor.download = filename;
    anchor.click();
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}

export async function downloadResponseAsFile(
  response: Response,
  fallbackFilename = "download.pgn",
): Promise<void> {
  const blob = await response.blob();
  const filename = getFilenameFromContentDisposition(
    response.headers.get("Content-Disposition"),
    fallbackFilename,
  );

  triggerBrowserDownload(blob, filename);
}
